<template>
  <div class="container page">
    <div class="new-header">
      <header class="header-top">
        <button type="button" class="header-back" @click="back()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m15 18-6-6 6-6"></path>
          </svg>
        </button>
        <h1 class="header-title">{{ lottery.name_zh_cn || $t('reservation.entrance_default') }}</h1>
        <div class="header-right">
          <button type="button" class="header-entrance" @click="showEntranceMenu = !showEntranceMenu">
            <span>{{ lottery.name_zh_cn || $t('reservation.entrance_default') }}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="m6 9 6 6 6-6"></path>
            </svg>
          </button>
          <!-- 下拉菜单：展示首页4个投票入口产品 -->
          <transition name="fade">
            <div class="entrance-menu" v-if="showEntranceMenu">
              <div
                class="entrance-menu-item"
                :class="{ active: lottery && lottery.id && String(lottery.id) === String(v.id) }"
                v-for="(v, key) in entranceList"
                :key="key"
                @click="toEntrance(v.key, v.id)"
              >
                <span class="entrance-dot"></span>
                <span class="entrance-name">{{ v.name_zh_cn || ($t('reservation.entrance_prefix') + (key + 1)) }}</span>
                <van-icon v-if="lottery && lottery.id && String(lottery.id) === String(v.id)" name="success" class="entrance-check" />
              </div>
              <div class="entrance-menu-empty" v-if="entranceList.length === 0">
                <span>{{ $t('reservation.no_entrance') }}</span>
              </div>
            </div>
          </transition>
        </div>
      </header>
      <div class="header-notice">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"></path>
          <path d="M16 9a5 5 0 0 1 0 6"></path>
          <path d="M19.364 18.364a9 9 0 0 0 0-12.728"></path>
        </svg>
        <p class="notice-text">{{ lottery.desc || $t('reservation.play_desc_default') }}</p>
      </div>
      <div class="header-tabs">
        <button type="button" class="header-tab" :class="{ active: activeTab === 'vote' }" @click="activeTab = 'vote'">{{ $t('reservation.vote') }}</button>
        <button type="button" class="header-tab" :class="{ active: activeTab === 'record' }" @click="activeTab = 'record'">{{ $t('reservation.recent_vote') }}</button>
        <div class="header-tab header-amount">
          <span>{{ $t('reservation.unit') }}</span>
          <!-- 👁眼睛图标：点击切换余额显示/隐藏；默认隐藏showBalance=false -->
          <button type="button" class="eye-btn" @click.stop="showBalance = !showBalance">
            <svg v-if="showBalance" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="eye-icon eye-icon--open">
              <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="eye-icon eye-icon--closed">
              <!-- 闭眼/隐藏：带斜杠的眼睛图标 -->
              <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7.5 0-10-8-10-8a19.77 19.77 0 0 1 4.22-5.19"></path>
              <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7.5 0 10 8 10 8a19.8 19.8 0 0 1-3.17 4.19"></path>
              <path d="M14.12 14.12A3 3 0 1 1 9.88 9.88"></path>
              <line x1="2" y1="2" x2="22" y2="22"></line>
            </svg>
          </button>
          <span class="amount-num">{{ showBalance ? (userInfo.money || '0.00') : ' ****' }}</span>
        </div>
      </div>
    </div>
    <div class="vote-content" v-if="activeTab === 'vote'">
    <div class="record">
      <!-- 左列：数字大的 = 当前倒计时期（结构：title+body 与右列对齐） -->
      <div class="period-col period-col--left">
        <div class="period-title">
          <span>{{ formatExpect(currentPeriod) }}{{ $t('reservation.round') }}</span>
        </div>
        <div class="period-body">
          <van-count-down class="countdown-text" :time="time" @finish="check()" />
        </div>
      </div>
      <!-- 右列：数字小的 = 已开奖结果期（结构：title+body 与左列对齐） -->
      <div class="period-col period-col--right">
        <div class="period-title" @click="active ? active = false : active = true">
          <span>{{ formatExpect(lastPeriod) }}{{ $t('reservation.round_result') }}</span>
          <van-icon name="arrow-down" :class="{ up: active, down: !active }" />
        </div>
        <div class="period-body">
          <span class="result-word result-word-1">{{ resultWord1 || '--' }}</span>
          <span class="result-word result-word-2">{{ resultWord2 || '--' }}</span>
        </div>
      </div>
    </div>
    <div class="history_popup"></div>
    <!-- 投票分隔标题行 -->
    <div class="vote-section-title">{{ $t('reservation.vote') }}</div>
    <div class="wrapper">
        <div class="options-bar">
            <div class="game">
             <!--    <div class="tips">
                <p class="odds">【{{this.lottery.desc}}】</p>
                <div class="play-tip" >
                  <van-icon name="more-o" />
               <span class="span-text" @click="playgame = true">玩法提示</span>
                  <span class="span-text" @click="$router.push({path:'/GameRecord'});">{{$t("my.task_record")}}</span>
                  <van-popup  class="mask" get-container="body" v-model="playgame">
                      <div class="play-type-tip">
                        <div class="title">玩法规则</div>
                        <div class="wrapper">
                          <div class="item">
                              <van-icon name="info-o" />
                              <div class="content">
                                <p class="content-title">玩法提示</p>
                                <p class="content-detail">从可选和值形态里面选择号码进行下注</p>
                              </div>
                          </div>
                          <div class="item">
                            <van-icon name="comment-o" />
                            <div class="content">
                              <p class="content-title">中奖说明</p>
                              <p class="content-detail">三个开奖号码总和值11~18 为大;总和值3~ 10为小;</p>
                            </div>
                          </div>
                          <div class="item">
                            <van-icon name="description" />
                            <div class="content">
                              <p class="content-title">投注范例</p>
                              <p class="content-detail">投注方案：小 开奖号码：123,即中小</p>
                            </div>
                          </div>
                        </div>
                      </div>
                  </van-popup>
                </div>
              </div>-->
              <div class="linear-gradient" style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));"></div>
              <div class="sumValueTwoSides">
                <div class="rectangle large" :class="{active:choose[v.type]}" v-for="(v,key) in lottery_peilv_list" :key="key" @click="choosePlay(v.type,v.name);">
                  <div class="wrapper">
                    <div class="content">
                      <p class="name-text large">{{v.name}}</p>
                      <p class="odd-text large" style="opacity: 0;">{{v.proportion}}</p>
                    </div>
                  </div>
                </div>
              </div>
   <div class="promo-images">
      <img src="/img/detail/1.png" alt="" class="promo-img" loading="lazy" />
      <img src="/img/detail/2.png" alt="" class="promo-img" loading="lazy" />
    </div>
            </div>
        </div>
        <div class="bottom-bar">
          <div class="bar">
         <!--   <div class="left">
              <div class="item" @click="shopping ? shopping = false : shopping = true ">
                <van-icon name="cart-o" class="jixuanico" />
                <span class="text">{{$t("reservation.task_list")}}</span>
              </div>
              <div class="line"></div>
            </div>-->
            <div class="mid">
              <span class="text label">{{$t("reservation.available_balance")}}</span>
              <div class="balance-row">
                <span class="text num">{{ showBalance ? (userInfo.money || '0.00') : ' ****' }}</span>
                <span class="text unit">{{$t("reservation.unit")}}</span>
              </div>
            </div>
            <div class="right" @click="jiesuan()">
              {{$t("reservation.submit")}}
            </div>
          </div>
      </div>
    </div>
      <van-popup
        v-model="jiesuanpage"
        position="bottom"
        get-container="body"
        :overlay="false"
        :close-on-click-overlay="false"
        :lock-scroll="false"
        class="vote-keyboard-popup"
      >
        <div class="vote-keyboard">
          <div class="vote-top-bar">
            <button type="button" class="vote-amount-btn">{{ money || '1' }}</button>
            <button type="button" class="vote-unit-btn">{{ $t('reservation.unit') }}</button>
          </div>
          <div class="vote-mid-bar">
            <button type="button" class="vote-clear-btn" @click="clearNum">{{ $t('reservation.clear') }}</button>
            <p class="vote-summary">{{ $t('reservation.count_label') }} <span class="vote-red">{{ formData.length }}</span> {{ $t('reservation.ticket_unit') }}, {{ $t('reservation.count_label') }} <span class="vote-red">{{ (money * formData.length) || 0 }}</span>{{ $t('reservation.ticket_unit') }}</p>
            <button type="button" class="vote-submit-btn" @click="doSub">{{ $t('reservation.submit') }}</button>
          </div>
          <div class="vote-keypad">
            <button type="button" class="vote-key" @click="inputNum('1')">1</button>
            <button type="button" class="vote-key" @click="inputNum('2')">2</button>
            <button type="button" class="vote-key" @click="inputNum('3')">3</button>
            <button type="button" class="vote-key" @click="inputNum('4')">4</button>
            <button type="button" class="vote-key" @click="inputNum('5')">5</button>
            <button type="button" class="vote-key" @click="inputNum('6')">6</button>
            <button type="button" class="vote-key" @click="inputNum('7')">7</button>
            <button type="button" class="vote-key" @click="inputNum('8')">8</button>
            <button type="button" class="vote-key" @click="inputNum('9')">9</button>
            <button type="button" class="vote-key" @click="inputNum('00')">00</button>
            <button type="button" class="vote-key" @click="inputNum('0')">0</button>
            <button type="button" class="vote-key vote-delete" @click="deleteNum">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z"></path>
                <path d="m12 9 6 6"></path>
                <path d="m18 9-6 6"></path>
              </svg>
            </button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="active" position="top" :style="{ height: '70%' }" >
              <van-pull-refresh :pulling-text="$t('reservation.refresh')"
			:loosing-text="$t('reservation.page_refresh')"
			:loading-text="$t('reservation.refresh')"
			:success-text="$t('reservation.refresh')" v-model="isLoading" @refresh="onRefresh">
                  <div class="history-wrapper">
                    <div class="history-header">
                      <div class="h-col h-col-1 font-weight">{{ $t('reservation.num') }}</div>
                      <div class="h-col h-col-2 font-weight">甜/言</div>
                      <div class="h-col h-col-3 font-weight">蜜/语</div>
                      <div class="h-col h-col-4 font-weight">{{ $t('reservation.auth_time') }}</div>
                    </div>
                    <div class="history-row" :class="{ 'row-alt': key % 2 === 1 }" v-for="(v,key) in lottery_list" :key="key">
                      <div class="h-col h-col-1">{{ formatExpect(v.expect) }}</div>
                      <div class="h-col h-col-2">
                        <span class="history-word">{{ getSize(v.opencode) }}</span>
                      </div>
                      <div class="h-col h-col-3">
                        <span class="history-word">{{ getType(v.opencode) }}</span>
                      </div>
                      <div class="h-col h-col-4">{{ formatOpenTime(v) }}</div>
                    </div>
                    <div class="history-more">
                      <button type="button" class="more-btn">{{ $t('reservation.view_more') }}</button>
                    </div>
                  </div>
              </van-pull-refresh>
        </van-popup>
        
    </div>
    <!-- 最近投票 tab：5列表格（期号|类型|投票内容|票数|操作）+ 空状态"当天没数据" -->
    <div class="record-content" v-if="activeTab === 'record'">
      <div class="vote-record-wrap">
        <table class="vote-record-table" cellpadding="0" cellspacing="0" border="0">
          <thead>
            <tr>
              <th class="col-expect">{{ $t('reservation.num') }}</th>
              <th class="col-type">{{ $t('reservation.type') }}</th>
              <th class="col-content">{{ $t('reservation.vote_content') }}</th>
              <th class="col-money">{{ $t('reservation.unit') }}</th>
              <th class="col-action">{{ $t('reservation.action') }}</th>
            </tr>
          </thead>
          <tbody v-if="recordList && recordList.length > 0">
            <tr v-for="(v, i) in recordList" :key="i" :class="{ 'row-alt': i % 2 === 1 }">
              <td class="col-expect">{{ formatExpect(v.expect) }}</td>
              <!-- 类型列：订单状态；除了"已结算"保持默认，其他状态全部显示红色 -->
              <td class="col-type">
                <span :class="{ 'status-red': v.status_text && v.status_text !== '已结算' }">
                  {{ v.status_text || v.name || '-' }}
                </span>
              </td>
              <!-- 投票内容列：客户的具体选择（甜/言/蜜/语），接口 v.type -->
              <td class="col-content vote-content-cell">
                <template v-if="v.type">{{ v.type }}</template>
                <template v-else-if="v.type_text">{{ v.type_text }}</template>
                <template v-else-if="v.play_type">{{ v.play_type }}</template>
                <template v-else>-</template>
              </td>
              <td class="col-money">{{ v.money }}</td>
              <td class="col-action">
                <!-- 操作按钮颜色：已结算赢绿 / 已结算输红 / 待结算灰（默认）
                     calcOrderResult 返回 {winState:'win'|'lose'|'pending', profit} -->
                <button
                  type="button"
                  class="record-action-btn"
                  :class="{
                    'btn-win':  calcOrderResult(v).winState === 'win',
                    'btn-lose': calcOrderResult(v).winState === 'lose'
                  }"
                  @click="openDetail(v)"
                >{{ $t('my.detail') }}</button>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 空状态：文档图标 + "当天没数据" -->
        <div class="record-empty" v-if="!recordList || recordList.length === 0">
          <div class="empty-icon">
            <svg viewBox="0 0 128 128" width="120" height="120" xmlns="http://www.w3.org/2000/svg">
              <rect x="32" y="16" width="64" height="96" rx="8" ry="8" fill="#f5f5f5" stroke="#dcdcdc" stroke-width="3"/>
              <rect x="44" y="36" width="40" height="4" rx="1.5" fill="#dcdcdc"/>
              <rect x="44" y="48" width="40" height="4" rx="1.5" fill="#dcdcdc"/>
              <rect x="44" y="60" width="40" height="4" rx="1.5" fill="#dcdcdc"/>
              <rect x="44" y="72" width="28" height="4" rx="1.5" fill="#dcdcdc"/>
              <rect x="44" y="88" width="12" height="6" rx="1" fill="#e8e8e8"/>
              <rect x="60" y="88" width="24" height="6" rx="1" fill="#e8e8e8"/>
            </svg>
          </div>
          <p class="empty-text">{{ $t('reservation.no_data_today') }}</p>
        </div>
        <!-- 查看更多按钮：跳转到 #/GameRecord 全部记录页 -->
        <div class="view-more-row">
          <button type="button" class="view-more-btn" @click="$router.push({path:'/GameRecord'})">
            <span>{{ $t('reservation.view_more') }}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="view-more-arrow">
              <path d="m9 18 6-6-6-6"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- 最近投票 → 详情弹窗：仅显示单个盈亏数字（正数绿/负数红） -->
    <van-popup
      v-model="showProfitPopup"
      round
      closeable
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="profit-popup-box">
        <div class="profit-title">{{ $t('reservation.order_profit') }}</div>
        <div
          class="profit-num"
          :class="{
            'profit-num--win': currentProfit != null && Number(currentProfit) > 0,
            'profit-num--lose': currentProfit != null && Number(currentProfit) < 0,
            'profit-num--draw': currentProfit != null && Number(currentProfit) === 0
          }"
        >
          <template v-if="currentProfit != null && currentProfit !== '' && !isNaN(Number(currentProfit))">
            {{ Number(currentProfit) > 0 ? '+' : '' }}{{ Number(currentProfit) }}
          </template>
          <template v-else>--</template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
      activeTab: 'vote',
      showEntranceMenu: false,
      jiesuanpage:false,
      choose: {
        "甜":false,
        "言":false,
        "蜜":false,
        "语":false,
        "3":false,
        "4":false,
        "5":false,
        "6":false,
        "7":false,
        "8":false,
        "9":false,
        "10":false,
        "11":false,
        "12":false,
        "13":false,
        "14":false,
        "15":false,
        "16":false,
        "17":false,
        "18":false,
      },
      playgame:false,
      shopping:false,
      isLoading: false,
      play:{},
      lottery_peilv_list:{},
      lottery_list:{},
      active: false,
      userInfo:{},
      lottery:{},
      shanzi_1:"0",
      shanzi_2:"0",
      shanzi_3:"0",
      sum:0,
      size:"",
      double:"",
      time:0,
      resultWord1: '',
      resultWord2: '',
      showBalance: false, // 票数/余额默认隐藏，点击眼睛图标切换
      entranceList: [{}, {}, {}, {}],
      shopchoose:this.$t("reservation.no_choose"),
      gameitem:"",
      formData:[],
      money:"",
      recordList: [],   // 最近投票列表（表格用）
      showProfitPopup: false,  // 详情盈亏弹窗开关
      currentProfit: null,     // 当前详情盈亏数字
    };
  },
  // 计算当前期（期号数字大的=倒计时中的一期，放左）和上一期（期号小的=已开奖，放右公布结果）
  computed: {
    currentPeriod() {
      const a = parseFloat(this.lottery && this.lottery.now_expect) || 0;
      const b = parseFloat(this.lottery && this.lottery.next_expect) || 0;
      return (a >= b ? (this.lottery.now_expect || '') : (this.lottery.next_expect || '')) || this.$t('reservation.period_loading');
    },
    lastPeriod() {
      const a = parseFloat(this.lottery && this.lottery.now_expect) || 0;
      const b = parseFloat(this.lottery && this.lottery.next_expect) || 0;
      return (a <= b ? (this.lottery.now_expect || '') : (this.lottery.next_expect || '')) || this.$t('reservation.period_loading');
    }
  },
  watch: {
    // 路由query变化（切换不同投票入口）时，强制重新加载所有数据，相当于页面刷新
    '$route.query': {
      deep: true,
      immediate: false,
      handler(newQ, oldQ) {
        if (!newQ) return;
        const keyChanged = newQ.key !== (oldQ && oldQ.key);
        const idChanged  = String(newQ.id || '') !== String((oldQ && oldQ.id) || '');
        if (keyChanged || idChanged) {
          // 清掉旧入口的状态：选中、金额、表单、弹窗
          this.resetState();
          // 重新请求所有初始化接口
          this.initData();
        }
      }
    }
  },
  methods: {
    // 重置页面所有状态（选择/金额/表单/弹窗）
    resetState() {
      const newChoose = {};
      Object.keys(this.choose || {}).forEach(k => { newChoose[k] = false; });
      this.choose = newChoose;
      this.money = '';
      this.formData = [];
      this.jiesuanpage = false;
      this.showEntranceMenu = false;
      this.active = false;
      this.playgame = false;
      this.shopping = false;
      this.resultWord1 = '';
      this.resultWord2 = '';
    },
    // 初始化：created 和 路由切换时都会调用（相当于页面刷新）
    initData() {
      clearInterval(time);
      count = 0;
      this.getUserInfo();
      this.getEntranceList();    // 顶部4个投票入口
      this.getLotteryInfo();     // 当前彩票信息+开奖结果（会更新期号/开奖两字）
      this.getLotteryList();     // 历史记录
      this.getLotteryPeilv && this.getLotteryPeilv(); // 赔率列表
      this.getRecordList();      // 最近投票（表格）
      this.check();              // 启动轮询刷新
    },
    back(){
      return window.history.back();
    },
    getSum(opencode){
      return opencode[0] + opencode[1] + opencode[2];
    },
    getSize(opencode){
      var sum = opencode[0] + opencode[1] + opencode[2];
      return sum >= 11 && sum <= 18 ? '甜' : '言';
    },
    getType(opencode){
      var sum = opencode[0] + opencode[1] + opencode[2];
      return sum % 2 === 0 ? '语' : '蜜';
    },
    // 格式化期号：去掉前4位年份（如 2026072754 → 072754），短于5位原样显示
    formatExpect(expect){
      if(!expect) return '';
      const str = String(expect).trim();
      if(str.length <= 4) return str;
      if(/^\d{4}/.test(str)) return str.slice(4);
      return str;
    },
    // 格式化开奖时间：优先用接口返回的opentime/time字段，没有则基于期号末3位推算时间
    formatOpenTime(v){
      // 优先取接口真实时间字段
      if(v && (v.opentime || v.open_time || v.time || v.createtime || v.create_time)){
        const t = v.opentime || v.open_time || v.time || v.createtime || v.create_time;
        // 如果是时间戳或完整日期，提取HH:MM:SS
        if(typeof t === 'number' || /^\d+$/.test(String(t))){
          const d = new Date(t * (String(t).length === 10 ? 1000 : 1));
          if(!isNaN(d.getTime())){
            return d.toTimeString().slice(0,8);
          }
        }
        // 如果已经是HH:MM:SS或带日期的字符串
        const str = String(t);
        const m = str.match(/(\d{1,2}:\d{2}:\d{2})/);
        if(m) return m[1];
        return str.length > 8 ? str.slice(-8) : str;
      }
      // 兜底：按期号末3位生成一个伪时间（仅供展示，与高仿图排版一致）
      const expect = v && v.expect ? String(v.expect) : '';
      const last3 = expect.length >= 3 ? parseInt(expect.slice(-3), 10) : 0;
      const baseHour = 17;
      const totalMin = last3;
      const h = String(baseHour + Math.floor(totalMin / 60) % 7).padStart(2, '0');
      const m = String(totalMin % 60).padStart(2, '0');
      const s = String((last3 * 7) % 60).padStart(2, '0');
      return `${h}:${m}:${s}`;
    },
    doSub(){
      if(this.money === "0"){
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if(this.formData.length === 0){
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      }else if(this.money === ""){
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if(this.userInfo.money - (this.money * this.formData.length) < 0 ){
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        }else {
          this.$http({
            method: 'post',
            data:{
               item:this.gameitem,
               money:this.money,
               lid:this.lottery.id,
               mid:this.userInfo.id,
               expect:this.lottery.now_expect
            },
            url: 'game_place_order'
          }).then(res=>{
            if(res.code === 200){
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            }else if(res.code === 401){
              this.$toast(res.msg);
            }
          })
          return true;
        }
      }
    },
    allClear(){
      for(var i = 0;i<this.formData.length;i++){
          this.choose[this.formData[i]['type']] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem ="";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    jiesuan(){
      if(this.formData.length === 0){
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      }else if(this.money === "" || this.money === "0"){
        this.jiesuanpage = true;
        return false;
      }
      this.doSub();
    },
    inputNum(num){
      if(num === '00'){
        if(this.money === '' || this.money === undefined) return;
        this.money = this.money + '00';
      }else{
        this.money = (this.money || '') + num;
      }
    },
    deleteNum(){
      this.money = (this.money || '').toString().slice(0, -1);
    },
    clearNum(){
      this.money = '';
    },
    clearChooes(type){
      for(var i = 0;i<this.formData.length;i++){
        if(type === this.formData[i]['type'] ){
          this.formData.splice(i,1)
          this.choose[type] = false;
        }
      }
      if(this.formData.length >= 1){
        for(var j = 0;j < this.formData.length;j++){
          if(j === 0){
            this.shopchoose = this.formData[j]['name'];
            this.gameitem = this.formData[j]['type'];
          }else {
            this.shopchoose += ","+this.formData[j]['name'];
            this.gameitem   += "," + this.formData[j]['type'];
          }
        }
      }else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if(this.formData.length === 0){
        this.jiesuanpage = false;
      }
    },
    choosePlay(type,name){
        if(this.choose[type] === true){
          this.choose[type] = false;
          for(var i = 0;i<this.formData.length;i++){
            if(type === this.formData[i]['type'] ){
                this.formData.splice(i,1)
            }
          }
        }else if(this.choose[type] === false) {
          this.formData.push({'name':name, 'type':type})
          this.choose[type] = true;
          // 首次选中就弹出底部数字面板（金额输入）；遮罩已关闭，面板开着时仍可继续点上方其他按钮多选
          this.jiesuanpage = true;
        }
        if(this.formData.length === 1){
          this.shopping = true;
        }
        if(this.formData.length >= 1){
          for(var j = 0;j < this.formData.length;j++){
            if(j === 0){
              this.shopchoose = this.formData[j]['name'];
              this.gameitem = this.formData[j]['type'];
            }else {
              this.shopchoose += ","+this.formData[j]['name'];
              this.gameitem += ","+this.formData[j]['type'];
            }
          }
        }else {
          this.shopchoose = this.$t("reservation.no_choose");
          this.gameitem = "";
          this.shopping = false;
        }

    },
    check(){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        time = window.setInterval(() => {
          setTimeout(()=>{
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            this.getRecordList();   // 最近投票列表也同步刷新
            count++;
            if(count > 5){
              clearInterval(time);
              count = 0;
            }
          },0)
        }, 300)
      }
    },
    // 拉取最近投票列表（表格用），接口同 GameRecord.vue 里的 user_get_game_list
    getRecordList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
          // 优先展示当天的，若接口没有返回当天筛选则全部展示
          const arr = Array.isArray(res.data) ? res.data : [];
          // 过滤当前投票入口（按lottery.id / lid匹配）：只显示当前产品的记录
          const curId = this.lottery && this.lottery.id ? String(this.lottery.id) : '';
          const filtered = curId
            ? arr.filter(it => {
                const itLid = String(it.lid != null ? it.lid : (it.lottery_id != null ? it.lottery_id : ''));
                // 如果lid字段存在就过滤，否则保留全部记录（避免接口字段不同导致全空）
                return itLid ? itLid === curId : true;
              })
            : arr;
          this.recordList = filtered;
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      }).catch(()=>{
        // 接口失败则置空，不影响页面展示空状态
        this.recordList = [];
      });
    },
    // =====================================================
    // 最近投票：共用 订单胜负/盈亏 计算函数（严格对齐 hd.php 后端 settle() 规则）
    // 返回：{ winState: 'win'|'lose'|'pending', profit: number|null }
    //   - win=盈利(绿) / lose=亏损(红) / pending=结算中(灰)
    // =====================================================
    calcOrderResult(v){
      if(!v) v = {};
      const voteType = String(v.type || v.type_text || v.play_type || '').trim();
      const betMoney = parseFloat(v.money) || 0;

      // 0) 结算状态：status=1 且 is_win=1|2 才叫"已结算"
      const statusVal = v.status != null ? parseInt(v.status, 10) : null;
      const isWinVal  = v.is_win != null ? parseInt(v.is_win, 10) : null;
      const isSettled = (statusVal === 1) && (isWinVal === 1 || isWinVal === 2);

      // 1) 赔率：优先 v.peilv（下单时已写入订单的真实赔率）
      let odds = parseFloat(v.peilv);
      if (!odds || isNaN(odds) || odds <= 0) {
        odds = 1.95;
        if (voteType && this.lottery_peilv_list) {
          const peilvArr = Array.isArray(this.lottery_peilv_list)
            ? this.lottery_peilv_list
            : Object.values(this.lottery_peilv_list || {});
          for (const p of peilvArr) {
            if (String(p.type || p.name || p.play_type || '') === voteType) {
              // hd.php getLotteryPeilv() 取的是 proportion 字段
              const prop = p.proportion != null ? p.proportion :
                          p.odds != null ? p.odds :
                          p.peilv != null ? p.peilv :
                          p.rate != null ? p.rate :
                          p.payout != null ? p.payout : null;
              const pf = parseFloat(prop);
              if (!isNaN(pf) && pf > 0) { odds = pf; break; }
            }
          }
        }
      }

      // 2) 真实开奖码 opencode
      let opencode = null;
      const list = Array.isArray(this.lottery_list) ? this.lottery_list :
                   (this.lottery_list && typeof this.lottery_list === 'object' ? Object.values(this.lottery_list) : []);
      if (v.expect) {
        const found = list.find(x => String(x.expect || '') === String(v.expect));
        if (found && Array.isArray(found.opencode) && found.opencode.length >= 3) {
          opencode = found.opencode;
        }
      }
      if ((!opencode || opencode.length < 3) && Array.isArray(v.opencode) && v.opencode.length >= 3) {
        opencode = v.opencode;
      }

      // 3) 前端自算盈亏（仅"已结算"+有开奖码时才自算，避免未开奖乱判）
      let selfProfit = null;
      let selfWinBool = null;
      if (isSettled && voteType && betMoney > 0 && opencode && opencode.length >= 3) {
        const n1 = parseFloat(opencode[0]) || 0;
        const n2 = parseFloat(opencode[1]) || 0;
        const n3 = parseFloat(opencode[2]) || 0;
        const sum = n1 + n2 + n3;
        let win = false;
        if (voteType === '甜') win = (sum >= 11 && sum <= 18);
        else if (voteType === '言') win = (sum >= 3 && sum <= 10);
        else if (voteType === '蜜') win = (sum % 2 === 1);
        else if (voteType === '语') win = (sum % 2 === 0);
        else {
          const vn = parseFloat(voteType);
          if (!isNaN(vn) && vn >= 3 && vn <= 18 && vn === sum) win = true;
        }
        const won  = +(betMoney * odds).toFixed(2);
        const lost = -Number(betMoney.toFixed(2));
        selfProfit  = win ? won : lost;
        selfWinBool = win; // true/false
      }

      // 4) 最终 profit：前端自算 > 后端 profit > is_win 精确判断(is_win=1赢 / =2输 / =0不判)
      let profit = selfProfit;
      if (profit == null || (typeof profit === 'number' && isNaN(profit))) {
        profit = (v.profit !== undefined && v.profit !== null && v.profit !== '' && String(v.profit).trim() !== '')
          ? v.profit
          : null;
        if (profit == null) {
          if (v.amount != null && !isNaN(Number(v.amount))) {
            profit = v.amount;
          } else if (v.win_money != null) {
            profit = v.win_money;
          } else if (v.lose_money != null) {
            profit = -1 * Math.abs(Number(v.lose_money));
          } else if (isWinVal === 1) {
            profit = betMoney > 0 ? +(betMoney * odds).toFixed(2) : null;
          } else if (isWinVal === 2) {
            profit = betMoney > 0 ? -Number(betMoney.toFixed(2)) : null;
          }
          // isWinVal===0 / null：未结算，profit 保持 null
        }
      }

      // 5) 最终 winState：优先按 profit 正负；没有 profit 则按 is_win；否则 pending
      let winState = 'pending';
      if (selfWinBool === true) winState = 'win';
      else if (selfWinBool === false) winState = 'lose';
      else if (profit != null && !isNaN(Number(profit))) {
        winState = Number(profit) > 0 ? 'win' : (Number(profit) < 0 ? 'lose' : 'pending');
      } else if (isWinVal === 1) winState = 'win';
      else if (isWinVal === 2) winState = 'lose';
      // status=0 或 is_win=0 一律 pending（结算中）
      if (statusVal === 0 || isWinVal === 0 || isWinVal == null) {
        // 除非我们已经通过自算/profit确定了赢/亏，否则保持 pending
        if (selfWinBool == null && (profit == null || isNaN(Number(profit)))) {
          winState = 'pending';
        }
      }

      return { winState, profit };
    },
    // 最近投票 → 详情按钮点击：打开底部弹窗显示单个盈亏数字
    openDetail(v){
      const { winState, profit } = this.calcOrderResult(v);
      // winState 仅用于按钮颜色，弹窗直接用 profit 数字+符号显示颜色（正绿负红灰零）
      this.currentProfit = profit;
      this.showProfitPopup = true;
      // 避免 lint 报声明未用：实际上 calcOrderResult 的 winState 被按钮 class 用了，这里只取 profit
      void winState;
    },
    // 获取首页的4个投票入口（和首页 gameitem 同一个接口）
    getEntranceList() {
      this.$http({
        method: 'get',
        url: 'lottery_hot'
      }).then(res => {
        if (res.code === 200) {
          this.entranceList = res.data || [];
        }
      });
    },
    // 点击菜单项：跳转到对应的投票入口
    toEntrance(key, id) {
      if (!key || !id) {
        this.$toast(this.$t('reservation.invalid_entrance'));
        return;
      }
      this.showEntranceMenu = false;
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
        return;
      }
      const isSame = this.$route.query.key === key && String(this.$route.query.id) === String(id);
      // 关键：1)不同入口：直接 push 新key/id，App.vue的router-view key会变化→组件强制重建（等同刷新，又不会ERR_ABORTED）
      //       2)相同入口：加一个 _t 时间戳让 fullPath 变化，同样触发 key 变化→组件重建（手动刷新效果）
      const newQuery = { key, id };
      if (isSame) {
        newQuery._t = Date.now();
      }
      this.$router.push({ path: '/Lottery', query: newQuery });
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getLotteryPeilv(){
      this.$http({
        method: 'post',
        data:{id:this.$route.query.id},
        url: 'lottery_get_peilv'
      }).then(res=>{
        if(res.code === 200){
          this.lottery_peilv_list = res.data;
          // console.log( this.lottery_peilv_list)
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getLotteryList(){
      this.$http({
        method: 'get',
        data:{key:this.$route.query.key},
        url: 'lottery_get_one_list'
      }).then(res=>{
        if(res.code === 200){
          this.lottery_list = res.data;
          // console.log('lottery_list:')
          // console.log(res.data)
          this.getLotteryPeilv();
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getLotteryInfo(){
      this.$http({
        method: 'get',
        data:{key:this.$route.query.key},
        url: 'lottery_get_info'
      }).then(res=>{
        if(res.code === 200){
          if(parseFloat(this.userInfo.money) < parseFloat(res.data.condition)){
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({path:'/Home'})
            return false;
          }
          this.lottery = res.data;
          this.time = res.data.second * 1000;

          // if(this.time/1000 === 59){
          //   this.$toast(this.$t("reservation.prize_succ")+this.lottery.now_expect);
          // }
          const opencode = res.data.opencode;
          // 开奖两字：甜言蜜语 = 大小 + 单双 玩法（严格只基于真实opencode开奖码映射，不再猜任何name类字段）
          // 甜=大（和值≥11） 言=小（和值≤10） 蜜=单（和值单数） 语=双（和值双数）
          let r1 = '', r2 = '';
          if (opencode && Array.isArray(opencode) && opencode.length >= 3) {
            const n1 = parseInt(opencode[0], 10) || 0;
            const n2 = parseInt(opencode[1], 10) || 0;
            const n3 = parseInt(opencode[2], 10) || 0;
            const sum = n1 + n2 + n3;
            // 第1字：甜（大，和值≥11）/ 言（小，和值≤10）
            r1 = sum >= 11 ? '甜' : '言';
            // 第2字：蜜（单，和值单数）/ 语（双，和值双数）
            r2 = sum % 2 === 1 ? '蜜' : '语';
          }
          this.resultWord1 = r1;
          this.resultWord2 = r2;
          // 其它字段（骰子、sum、size、double）
          if(opencode && opencode.length >= 3){
            this.shanzi_1 = "img/lottery/shaizi/" + opencode[0] + ".png";
            this.shanzi_2 = "img/lottery/shaizi/" + opencode[1] + ".png";
            this.shanzi_3 = "img/lottery/shaizi/" + opencode[2] + ".png";
            this.sum = opencode[0] + opencode[1] + opencode[2];
            if(this.sum >= 11 && this.sum <=18){
              this.size = '甜';
            }else if(this.sum >= 3 && this.sum <= 10){
              this.size = '言';
            }
            if(this.sum % 2 === 0){
              this.double = '语';
            }else {
              this.double = '蜜';
            }
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })

    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.initData();
    }
  },
  destroyed() {
    clearInterval(time);
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.nav-bar .right{
  padding-left: 8px;
  padding-right: 8px;
  color: #fff;
  font-size: 28px;
  border-radius: 10px;
  border: 2px solid #fff;
  line-height: 60px;
}
.record{
  padding: 22px 20px 24px;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 #cacaca;
  z-index: 1;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 16px;
}
/* 左右两列：统一结构（period-title + period-body 垂直对齐） */
.record .period-col{
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  min-width: 0;
}
/* 顶部期号标签：左右统一高度/对齐/字体 */
.period-title{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  font-size: 26px;
  font-weight: 500;
  color: #222;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  .van-icon{
    flex-shrink: 0;
    font-size: 24px;
    color: #666;
  }
}
/* 右列标题点击可展开历史 */
.period-col--right .period-title{
  cursor: pointer;
}
/* 内容区（左：倒计时 / 右：甜 蜜 两字）统一垂直居中 */
.period-body{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 76px;
}
/* 倒计时文字 */
.countdown-text,
.period-body .countdown-text{
  color: #ff253f;
  font-size: 52px;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: 1px;
}
/* 开奖两字：甜/蜜 红色大字 */
.result-word{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.1;
  color: #ff253f;
  padding: 4px 6px;
}
/* 投票分隔标题 */
.vote-section-title{
  text-align: center;
  padding: 18px 0 14px;
  font-size: 28px;
  color: #666;
  background-color: #f2f2f5;
  border-bottom: 1px solid #e8e8e8;
}
.linear-gradient{
  width: 100%;
  height: 2px;
}
/* 全局van-count-down减小权重，在投票页面中被 .period-body .countdown-text 52px覆盖 */
.van-count-down {
  color: #ff253f;
  font-size: 45px;
}
.period-body .countdown-text.van-count-down {
  font-size: 52px;
  font-weight: 700;
}
.van-icon {
  font-size: 40px;
}
.down {
  transition: all .5s;
}
.up{
  transform: rotate(180deg);
  transition: all .5s;
}
.wrapper{
  position: relative;
  flex: 1;
  overflow: hidden;
}
.options-bar{
  display: flex;
  align-items: center;
  height: calc(100% - 80px);
}
.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.options-bar .game .tips{
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}
.options-bar .game .tips .odds{
  flex: 1;
  font-size: 35px;
  font-weight: 500;
  color: #ff253f;
}
.options-bar .game .tips .play-tip{
  display: flex;
  align-items: center;
  height: 100%;
}
::v-deep .van-icon-more-o{
  color: #ff253f;
  font-size: 50px;
}
.options-bar .game .tips .play-tip .span-text{
  margin-left: 10px;
  font-size: 35px;
  font-weight: bolder;
  color: #ff253f;
}
.linear-gradient{
  width: 100%;
  height: 2px;
}
.sumValueTwoSides{
  display: flex;
  padding: 30px 0 0;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.rectangle{
  overflow: hidden;
}
.rectangle.large{
  margin: 0 0 15px 4%;
  width: 20%;
  border-radius: 10px;
}
.rectangle .wrapper{
  position: relative;
  padding: 0 10px;
  background: #fff;
}
.rectangle .wrapper .content{
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.rectangle.large .wrapper{
  padding-bottom: 70%;
}
.rectangle .wrapper .content .name-text.large{
  font-size: 4vw;
}
.rectangle .wrapper .content .name-text{
  color: #7d7c7c;
  font-weight: bolder;
}
.rectangle .wrapper .content .odd-text.large{
  font-size: 25px;
  margin-top: -30px;
}
.rectangle .wrapper .content .odd-text{
  text-align: center;
  color: #ff253f;
}
.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 120px;
  z-index: 2;
}
.bottom-bar .bar{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 120px;
  background-color: #1a1a1a;
  box-shadow: 0 -2px 20px 0 rgba(0, 0, 0, 0.3);
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
}
.bottom-bar .bar .mid{
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.bottom-bar .bar .mid .text.label{
  font-size: 24px;
  color: #999;
}
.bottom-bar .bar .mid .balance-row{
  display: flex;
  align-items: baseline;
  margin-top: 4px;
}
.bottom-bar .bar .mid .text.num{
  font-size: 36px;
  font-weight: 600;
  color: #e6c3a1;
}
.bottom-bar .bar .mid .text.unit{
  margin-left: 8px;
  font-size: 24px;
  color: #999;
}
.bottom-bar .bar .right{
  padding: 0 60px;
  color: #fff;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
  font-size: 32px;
  font-weight: 500;
  height: 80px;
  line-height: 80px;
  border-radius: 40px;
  flex-shrink: 0;
  white-space: nowrap;
}
.rectangle.active .wrapper{
  background-color: #ff253f!important;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}
::v-deep   .van-popup {
  /* 只对顶部历史期号列表保持 absolute（不盖住其他内容），底部键盘面板保持 fixed */
  position: absolute;
}
::v-deep  .van-popup--top {
  top: -1px;
}
/* 底部数字金额键盘：fixed 贴底，无遮罩，允许上方继续点选投票按钮 + 滚动 */
::v-deep .vote-keyboard-popup.van-popup {
  position: fixed !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  max-width: 750px;
  margin: 0 auto;
  box-shadow: 0 -6px 30px rgba(0,0,0,0.35);
  border-top: 1px solid #333;
}
::v-deep .vote-keyboard-popup.van-popup::v-deep .van-popup__close-icon {
  display: none;
}
::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}
/* 历史记录列表整体 */
.history-wrapper{
  background-color: #fff;
  min-height: 100%;
}
.font-weight{
  font-weight: 700!important;
}
/* 表头 */
.history-header{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 18px 12px;
  background-color: #f2f2f5;
  border-bottom: 1px solid #e8e8e8;
}
/* 列通用 */
.h-col{
  text-align: center;
  font-size: 26px;
  color: #666;
}
.h-col-1{
  width: 22%;
}
.h-col-2{
  width: 22%;
}
.h-col-3{
  width: 22%;
}
.h-col-4{
  width: 34%;
}
/* 每行 */
.history-row{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 12px;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
}
.history-row.row-alt{
  background-color: #faf6f1;
}
.history-row .h-col{
  font-size: 28px;
  color: #222;
}
/* 开奖两字：红色大字 */
.history-word{
  display: inline-block;
  font-size: 38px;
  font-weight: 700;
  color: #c0392b;
  line-height: 1;
  letter-spacing: 1px;
}
/* 查看更多按钮 */
.history-more{
  padding: 30px 20px 40px;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
}
.more-btn{
  padding: 14px 56px;
  font-size: 28px;
  color: #555;
  background-color: transparent;
  border: 2px solid #bbb;
  border-radius: 30px;
  font-weight: 500;
}
.play-type-tip{
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  height: 700px;
  max-height: 50%;
  z-index: 10;
  border-radius: 30px;
  overflow: hidden;
  background-color: #fff;
  color: #000;
}
.play-type-tip .title{
  line-height: 90px;
  background: linear-gradient(
      90deg,#7e5678,#e6c3a1);
  text-align: center;
  color: #fff;
  font-size: 35px;
  font-weight: 500;
}
.mask{
  background-color: rgb(0 0 0 / 0%);
  animation-duration: 0.35s;
}
.play-type-tip .wrapper{
  height: calc(100% - 10px);
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.play-type-tip .wrapper .item{
  padding: 40px 50px;
  display: flex;
  align-items: flex-start;
}
.play-type-tip .wrapper .item .van-icon{
  color: #e6c3a1;
  font-size: 60px;
}
.play-type-tip .wrapper .item .content .content-title{
  margin-top: 22px;
  font-size: 35px;
  font-weight: 500;
  color: #000;
  line-height: 0px;
}
.play-type-tip .wrapper .item .content .content-detail{
  margin-top: 5px;
  font-size: 22px;
  color: #000;
  line-height: 30px;
}
.play-type-tip .wrapper .item .content{
  flex: 1;
  margin-left: 30px;
}
.rectangle.active .wrapper{
  background-color: #ff253f!important;
}
.rectangle.active .wrapper .name-text, .rectangle.active .wrapper .odd-text{
  color: #fff!important;
}
.bottom-bar .wrapper{
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  padding: 20px 20px 10px 20px;
  height: 230px;
  background-color: #fff;
  z-index: 1;
  box-shadow: 0 0 10px 0 #cacaca;
  transition: transform .3s cubic-bezier(.21,1.02,.55,1.01);
}
.bottom-bar .wrapper.active{
  transform: translateY(-100%);
}
.bottom-bar .wrapper .item{
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 65px;
}
.bottom-bar .wrapper .item .label{
  font-size: 30px;
  line-height: 30px;
  color: #000;
}
.bottom-bar .wrapper .item .bet-number{
  flex: 1;
  margin: 0 16px;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  color: #ff253f;
  font-size: 30px;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
}
.bottom-bar .wrapper .item .amount-wrapper{
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.van-cell {
  font-size: 30px;
  line-height: 50px;
}
.bottom-bar .wrapper .item .part{
  margin-right: 20px;
}
.bottom-bar .wrapper .item .part span{
  font-size: 30px;
  vertical-align: center;
  color: #000;
}
.bottom-bar .wrapper .item .part .number{
  margin: 0 5px;
  color: #ff253f;
  font-weight: 500;
}
::v-deep .van-field__control {
  color: #ff253f;
}
.vote-keyboard{
  width: 100%;
  background-color: #1a1a1a;
}
.vote-top-bar{
  display: flex;
  align-items: center;
  gap: 16px;
  border-top: 2px solid #333;
  padding: 24px;
}
.vote-amount-btn{
  height: 72px;
  min-width: 200px;
  border-radius: 12px;
  border: 2px solid #444;
  background: #0a0a0a;
  padding: 0 32px;
  text-align: center;
  font-size: 32px;
  color: #f487e0;
}
.vote-unit-btn{
  border-radius: 12px;
  border: 2px solid #8b2942;
  padding: 12px 32px;
  font-size: 28px;
  color: #ddd;
  background: transparent;
}
.vote-mid-bar{
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: #2a2a2a;
  padding: 20px 24px;
}
.vote-clear-btn{
  flex-shrink: 0;
  border-radius: 12px;
  border: 2px solid rgba(255,255,255,0.8);
  padding: 16px 32px;
  font-size: 28px;
  color: #fff;
  background: transparent;
}
.vote-summary{
  flex: 1;
  text-align: center;
  font-size: 30px;
  color: rgba(255,255,255,0.9);
  line-height: 1.5;
}
.vote-red{
  color: #ff4d4f;
  font-weight: 600;
}
.vote-submit-btn{
  flex-shrink: 0;
  border-radius: 12px;
  background: #e60012;
  padding: 16px 40px;
  font-size: 28px;
  font-weight: 500;
  color: #fff;
  border: none;
}
.vote-keypad{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 2px solid #333;
  background: #fff;
}
.vote-key{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  font-size: 44px;
  font-weight: 400;
  color: #333;
  border: none;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;
}
.vote-key:nth-child(3n){
  border-right: none;
}
.vote-key:nth-last-child(-n+3){
  border-bottom: none;
}
.vote-key:active{
  background: #f0f0f0;
}
.vote-delete svg{
  width: 48px;
  height: 48px;
  color: #333;
}
.next-number{
  display: flex;
  align-items: center;
}
.next-number span{
  font-size: 35px;
  font-weight: 700;
  color: #000;
}
.promo-images{
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 10px 16px 130px;
}
.promo-img{
  width: 100%;
  border-radius: 12px;
  display: block;
}
.new-header{
  background-color: #2b2b2b;
}
.header-top{
  position: relative;
  display: flex;
  align-items: center;
  padding: 20px 24px;
}
.header-back{
  z-index: 10;
  padding: 8px;
  background: none;
  border: none;
  color: #fff;
  svg{
    width: 40px;
    height: 40px;
  }
}
.header-title{
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  font-size: 32px;
  font-weight: 500;
  color: #fff;
  margin: 0;
  pointer-events: none;
}
.header-right{
  position: relative;
  z-index: 10;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.header-entrance{
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 24px;
  color: #fff;
  background: none;
  border: none;
  svg{
    width: 24px;
    height: 24px;
    margin-top: 4px;
    transition: transform .25s ease;
  }
}
/* 入口菜单：仿高仿图片的下拉弹出菜单（4个产品） */
.entrance-menu{
  position: absolute;
  top: calc(100% + 14px);
  right: 0;
  min-width: 280px;
  max-width: 320px;
  background-color: #fff;
  border-radius: 12px;
  padding: 10px 0;
  box-shadow: 0 8px 28px rgba(0,0,0,0.2);
  overflow: hidden;
  z-index: 99;
  animation: popIn .2s ease both;
  &::before{
    content: '';
    position: absolute;
    top: -8px;
    right: 28px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fff;
  }
}
.entrance-menu-item{
  display: flex;
  align-items: center;
  padding: 14px 20px 14px 16px;
  cursor: pointer;
  transition: background-color .15s ease;
  &:hover, &:active{
    background-color: #fafafa;
  }
  &.active{
    background-color: #fff1f0;
    .entrance-name{
      color: #ff253f;
      font-weight: 600;
    }
    .entrance-dot{
      background-color: #ff253f;
    }
  }
}
.entrance-dot{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ddd;
  flex-shrink: 0;
  margin-right: 14px;
}
.entrance-name{
  flex: 1;
  font-size: 26px;
  color: #222;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.entrance-check{
  color: #ff253f;
  font-size: 28px !important;
  margin-left: 8px;
}
.entrance-menu-empty{
  padding: 24px;
  text-align: center;
  font-size: 24px;
  color: #999;
}
/* fade过渡 */
.fade-enter-active,
.fade-leave-active{
  transition: opacity .2s ease, transform .2s ease;
}
.fade-enter-from,
.fade-leave-to{
  opacity: 0;
  transform: translateY(-6px);
}
@keyframes popIn{
  from{ opacity: 0; transform: translateY(-4px) scale(.98); }
  to  { opacity: 1; transform: translateY(0) scale(1); }
}
.header-notice{
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #252525;
  padding: 16px 24px;
  svg{
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    color: #00bcd4;
  }
  .notice-text{
    margin: 0;
    flex: 1;
    font-size: 24px;
    color: rgba(255,255,255,0.6);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.header-tabs{
  display: flex;
  align-items: stretch;
  background-color: #333;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}
.header-tab{
  position: relative;
  flex: 1;
  padding: 24px 0;
  text-align: center;
  font-size: 28px;
  background: none;
  border: none;
  color: rgba(248,215,218,0.8);
  &.active{
    font-weight: 500;
    color: #fff;
    &::after{
      content: '';
      position: absolute;
      bottom: 0;
      left: 25%;
      right: 25%;
      height: 6px;
      background-color: #fff;
    }
  }
  &.header-amount{
    flex: none;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-variant-numeric: tabular-nums;
    cursor: default;
    /* 👁眼睛按钮：可点击切换显示/隐藏 */
    .eye-btn{
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      padding: 0;
      background: none;
      border: none;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      transition: transform .15s ease, opacity .15s ease;
      &:active{
        transform: scale(0.9);
      }
      .eye-icon{
        width: 28px;
        height: 28px;
        flex-shrink: 0;
      }
      .eye-icon--open{
        color: rgba(255,255,255,0.85);
      }
      .eye-icon--closed{
        color: rgba(255,255,255,0.45);
      }
    }
    svg{
      width: 28px;
      height: 28px;
    }
    .amount-num{
      margin-left: 4px;
      min-width: 6em;
      text-align: left;
      letter-spacing: 1px;
    }
  }
}
.vote-content{
 // background-color: #0a0a0a;
  padding-bottom: 120px;
  box-sizing: border-box;
  min-height: 100vh;
}
.record-content{
  background-color: #f2f2f5;
  min-height: calc(100vh - 160px);
  padding: 16px;
}
.record-empty{
  text-align: center;
  color: #666;
  padding: 60px 0;
  font-size: 14px;
}
.record-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #1a1a2e;
  border-radius: 12px;
  margin-bottom: 12px;
}
.record-item-left{
  display: flex;
  flex-direction: column;
  gap: 6px;
  .record-expect{
    font-size: 14px;
    color: #fff;
    font-weight: 500;
  }
  .record-names{
    font-size: 12px;
    color: rgba(255,255,255,0.6);
  }
}
.record-item-right{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  .record-amount{
    font-size: 16px;
    color: #f487e0;
    font-weight: 500;
  }
  .record-status{
    font-size: 12px;
    color: #999;
    &.win{
      color: #4ade80;
    }
    &.lose{
      color: #f87171;
    }
  }
}

/* ================================
   最近投票 tab 表格样式（高仿5.png）
   ================================ */
.vote-record-wrap{
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
}
.vote-record-table{
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  font-size: 26px;
  color: #333;
  thead{
    tr{
      background-color: #fafafa;
      border-bottom: 1px solid #eaeaea;
    }
    th{
      padding: 20px 8px;
      text-align: center;
      font-weight: 500;
      color: #333;
      font-size: 26px;
      border-bottom: 1px solid #eaeaea;
      white-space: nowrap;
    }
    th.col-expect  { width: 18%; }
    th.col-type    { width: 20%; }
    th.col-content { width: 28%; }
    th.col-money   { width: 16%; }
    th.col-action  { width: 18%; }
  }
  tbody{
    tr{
      background-color: #fff;
      border-bottom: 1px solid #f0f0f0;
      transition: background-color .15s ease;
      &:last-child{
        border-bottom: none;
      }
      &.row-alt{
        background-color: #fafafa;
      }
      &:active{
        background-color: #f5f5f5;
      }
    }
    td{
      padding: 22px 8px;
      text-align: center;
      font-size: 26px;
      color: #333;
      vertical-align: middle;
      word-break: break-all;
      line-height: 1.3;
    }
    td.col-expect{
      font-weight: 600;
      color: #222;
      font-variant-numeric: tabular-nums;
    }
    td.col-money{
      font-weight: 600;
      color: #ff253f;
      font-variant-numeric: tabular-nums;
    }
  }
}
/* 操作按钮：默认灰色（待结算状态） */
.record-action-btn{
  display: inline-block;
  padding: 10px 22px;
  font-size: 24px;
  color: #666;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background-color .15s ease, transform .1s ease, border-color .15s ease, color .15s ease;
  &:active{
    background-color: #eeeeee;
    transform: scale(0.96);
  }
}
/* 最近投票-已结算：赢 → 绿色实心按钮 */
.record-action-btn.btn-win{
  background-color: #07c160;
  color: #ffffff;
  border-color: #07c160;
  font-weight: 700;
  &:active{
    background-color: #06ad56;
    border-color: #06ad56;
    transform: scale(0.96);
  }
}
/* 最近投票-已结算：输 → 红色实心按钮 */
.record-action-btn.btn-lose{
  background-color: #ff253f;
  color: #ffffff;
  border-color: #ff253f;
  font-weight: 700;
  &:active{
    background-color: #e61f36;
    border-color: #e61f36;
    transform: scale(0.96);
  }
}
/* 最近投票空状态：居中文档图标 + 当天没数据文字 */
.record-empty{
  width: 100%;
  padding: 120px 24px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
  .empty-icon{
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.9;
  }
  .empty-text{
    margin: 0;
    font-size: 28px;
    color: #999;
    letter-spacing: 1px;
  }
}
/* 类型列状态色：除了"已结算"，其他状态（待开奖/开彩中…）全部显示红色 */
.status-red{
  color: #ff253f !important;
  font-weight: 600;
}
/* 投票内容列：甜/言/蜜/语 稍微加大加粗，颜色用主题红 */
.vote-content-cell{
  font-weight: 700;
  font-size: 30px;
  color: #ff253f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* 最近投票 → 详情盈亏弹窗 */
.profit-popup-box{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 60px;
  box-sizing: border-box;
  gap: 40px;
}
.profit-title{
  font-size: 32px;
  font-weight: 500;
  color: #333;
  letter-spacing: 2px;
}
.profit-num{
  font-size: 120px;
  font-weight: 700;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
  letter-spacing: 2px;
  text-align: center;
  /* 默认灰色（平局/无效数据） */
  color: #999;
}
/* 正数盈利：绿色 */
.profit-num--win{
  color: #07c160;
}
/* 负数亏损：红色 */
.profit-num--lose{
  color: #ff253f;
}
/* 0或平局：灰色保持默认 */
.profit-num--draw{
  color: #999;
}
/* ========== 最近投票 tab → 查看更多按钮 ========== */
.view-more-row{
  width: 100%;
  padding: 18px 16px 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
}
.view-more-btn{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 30px;
  font-size: 26px;
  color: #666;
  background-color: #f7f7f7;
  border: 1px solid #e5e5e5;
  border-radius: 999px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background-color .15s ease, color .15s ease, border-color .15s ease, transform .1s ease;
  &:active{
    background-color: #eeeeee;
    border-color: #dddddd;
    color: #333;
    transform: scale(0.97);
  }
  .view-more-arrow{
    width: 22px;
    height: 22px;
    stroke: #888;
  }
}
</style>
